import React from "react";
import {motion} from "framer-motion";

const Roadmap = () => {
  return (
    <>
      <div id="roadmap">
        <div className="timeline-container" id="timeline-1">
          <div className="timeline-header">
            <div id="" className="c padded">
              <motion.div 
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ ease: "easeOut", duration: 1 }} className="text-style-all-caps">Building The Future</motion.div>
              <motion.h1 
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ ease: "easeOut", duration: 1 }} className="heading-xlarge">
                &nbsp;
                <span className="color-text-gradient">
                  ECOSYSTEM ROADMAP...
                </span>
              </motion.h1>
              <motion.span 
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ ease: "easeOut", duration: 1 }} className="timeline-description ">
                Cloudax is a rapidly expanding ecosystem designed to innovate
                with various value-added utilities to continuously drive the
                economic growth of the ecosystem.
              </motion.span>
            </div>
          </div>
          <div className="timeline">
            <div id="timeline1" className="timeline-item" data-text="June-2022">
              <div className="timeline__content">
                <img className="timeline__img" src="images/ideation.jpeg" />
                <h2 className="timeline__content-title">Ideation</h2>
                <p className="timeline__content-desc"></p>
                <ul>
                  <li className="timelineLi">Ideation</li>
                  <li className="timelineLi">Team Formation</li>
                  <li className="timelineLi">Market survey and analysis.</li>
                </ul>
                <p />
              </div>
            </div>
            <div className="timeline-item" data-text="August-2022">
              <div className="timeline__content">
                <img className="timeline__img" src="images/community.jpeg" />
                <h2 className="timeline__content-title">COMMUNITY GROWTH</h2>
                <p className="timeline__content-desc"></p>
                <ul>
                  <li className="timelineLi">Pre-Launch Marketing</li>
                  <li className="timelineLi">Community Reach Initiative</li>
                  <li className="timelineLi">Growth Strategy</li>
                </ul>
                <p />
              </div>
            </div>
            <div className="timeline-item" data-text="September-2022">
              <div className="timeline__content">
                <img className="timeline__img" src="images/development.jpeg" />
                <h2 className="timeline__content-title">
                  DEVELOPMENT &amp; TOKEN LAUNCH
                </h2>
                <p className="timeline__content-desc"></p>
                <ul>
                  <li className="timelineLi">Token Platform Launch</li>
                  <li className="timelineLi">Ecosystem Testnet</li>
                  <li className="timelineLi">Mainnet</li>
                  <li className="timelineLi">Token Presale</li>
                  <li className="timelineLi">Staking</li>
                  <li className="timelineLi">Partnerships</li>
                  <li className="timelineLi">Liquidity Pool</li>
                </ul>
                <p />
              </div>
            </div>
            <div className="timeline-item" data-text="October-2022 PHASE 4">
              <div className="timeline__content">
                <img
                  className="timeline__img"
                  src="images/NFT-Marketplace.jpeg"
                />
                <h2 className="timeline__content-title">NFT MARKETPLACE</h2>
                <p className="timeline__content-desc"></p>
                <ul>
                  <li className="timelineLi">NFT Marketplace Testnet</li>
                  <li className="timelineLi">Mainnet Launch</li>
                  <li className="timelineLi">Chain Bridge</li>
                  <li className="timelineLi">Token Integrations</li>
                  <li className="timelineLi">NFT Launchpad</li>
                </ul>
                <p />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Roadmap;
